import React, { useEffect, useRef } from 'react'

import { useFavoriteToast } from '../../../lib/favorites/hooks/useFavoriteToast'
import { pendingFavorite$ } from '../../../lib/favorites/state/pending'

/**
 * Holds the single subscription that replays a favorite clicked before login. Mounted once in the
 * root element wrapper: it lives in React only because the error toast needs toast context, and it
 * subscribes once for the app lifetime so an in-flight replay is never cancelled by a re-render.
 */
export const PendingFavoriteResume: React.VFC = () => {
  const { showErrorToast } = useFavoriteToast()
  const showErrorToastRef = useRef(showErrorToast)

  useEffect(() => {
    showErrorToastRef.current = showErrorToast
  }, [showErrorToast])

  useEffect(() => {
    const subscription = pendingFavorite$.subscribe((result) => {
      if (result._tag === 'Left') {
        showErrorToastRef.current(result.error.productName)
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  return null
}
